import axios from 'axios'
import Cookie from 'js-cookie'
import Vue from 'vue'
import store from '@/store'
import { Toast } from 'vant'
import { getQueryString } from '@/utils/xl_utils'

const [userId, orgCode, userName] = [getQueryString('userId'), getQueryString('orgCode'), getQueryString('userName')]
if (userId) Cookie.set('userId', userId)
if (orgCode) Cookie.set('orgCode', orgCode)
if (userName) Cookie.set('userName', userName)
Vue.use(Toast)
// 跨域认证信息 header 名
const xsrfHeaderName = 'Authorization'

axios.defaults.timeout = 10000
axios.defaults.withCredentials = true
axios.defaults.xsrfHeaderName = xsrfHeaderName
axios.defaults.xsrfCookieName = xsrfHeaderName
// 为了配置接口在headers中的默认值
axios.defaults.headers = {
  appid: '7',
  userId: Cookie.get('userId') || '',
  orgCode: Cookie.get('orgCode') || '',
  'APP-ID': 'yxztWtv7771M0yJMAL',
  'APP-KEY': '9f775c2370b2004c7490fbdd6e5762fcde5a3b62'
}

// 设置要取消重复请求的接口地址
const cancelList = [
  '/api/document/app/fourEntrances/getDealList',
  '/api/empticket/app/ticketApply/queryTicketApplyList', // 出票记录
  '/api/empticket/app/refundEmpTicket/queryRefundTicketList', // 退票记录
  '/api/document/app/contract/mysList' //合同台账
]
let pending = [] //声明一个数组用于存储每个请求的取消函数和axios标识
let cancelToken = axios.CancelToken
let removePending = config => {
  for (let p in pending) {
    //由于不同的环境ip或者baseUrl不一样，这里需要取出相同的部分
    //比如 192.168.0.132:3000/api/document/app/fourEntrances/getDealList和192.168.0.40:3000/api/document/app/fourEntrances/getDealList
    //我们只取vaCantRoom/listPage,如上cancelList的第一个
    let formatU = pending[p].u.split('&')[0]
    if (cancelList.indexOf(formatU) > -1) {
      if (pending[p].u === config.url + '&' + config.method) {
        //当当前请求在数组中存在时执行函数体
        pending[p].f() //执行取消操作
        pending.splice(p, 1)
      }
    }
  }
}

// 认证类型
const AUTH_TYPE = {
  BEARER: 'Bearer',
  BASIC: 'basic',
  AUTH1: 'auth1',
  AUTH2: 'auth2'
}

// http method
const METHOD = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete'
}

/**
 * axios请求
 * @param url 请求地址
 * @param method {METHOD} http method
 * @param params 请求参数
 * @returns {Promise<AxiosResponse<T>>}
 */
async function request(url, method, params, config) {
  switch (method) {
    case METHOD.GET:
      return axios.get(url, { params, ...config })
    case METHOD.POST:
      // if (params instanceof FormData) {
      // params.append('version', '1.0')
      return axios.post(url, params, config)
    // } else {
    //   return axios.post(url, { request: params, header: { version: '1.0' } }, config)
    // }
    case METHOD.DELETE:
      return axios.delete(url, { params, ...config })
    case METHOD.PUT:
      // return axios.put(url, params, config)
      return axios.put(url, { request: params }, config)
    default:
      return axios.get(url, { params, ...config })
  }
}

/**
 * 设置认证信息
 * @param auth {Object}
 * @param authType {AUTH_TYPE} 认证类型，默认：{AUTH_TYPE.BEARER}
 */
function setAuthorization(auth, authType = AUTH_TYPE.BEARER) {
  switch (authType) {
    case AUTH_TYPE.BEARER:
      Cookie.set(xsrfHeaderName, 'Bearer ' + auth.token, {
        expires: auth.expireAt
      })
      break
    case AUTH_TYPE.BASIC:
    case AUTH_TYPE.AUTH1:
    case AUTH_TYPE.AUTH2:
    default:
      break
  }
}

/**
 * 移出认证信息
 * @param authType {AUTH_TYPE} 认证类型
 */
function removeAuthorization(authType = AUTH_TYPE.BEARER) {
  switch (authType) {
    case AUTH_TYPE.BEARER:
      Cookie.remove(xsrfHeaderName)
      break
    case AUTH_TYPE.BASIC:
    case AUTH_TYPE.AUTH1:
    case AUTH_TYPE.AUTH2:
    default:
      break
  }
}
// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (config?.tgc) {
      config.headers.tgc = config?.tgc
    }
    config.headers.userName = store.state.user.userName || Cookie.get('username') || ''
    config.headers.Authorization = 'Bearer ' + Cookie.get('token')
    removePending(config) //在一个axios发送前执行一下取消操作
    config.cancelToken = new cancelToken(c => {
      // 唯一标识，用来判断是否是同一个请求
      pending.push({ u: config.url + '&' + config.method, f: c })
    })
    return config
  },
  err => {
    return Promise.reject(err)
  }
)
axios.interceptors.response.use(
  res => {
    //全局拦截响应，拦截错误信息或者返回的对象格式
    const { code, msg } = res.data || {}
    if (code == '401') {
      Toast('登录状态已过期，请重新登录', 3)
      setTimeout(() => {
        Vue.prototype.$native.api.logout()
      }, 2000)
      return Promise.reject(new Error(msg))
    }
    if (['400', '500'].includes('' + code)) {
      if (!res.config?.hideErrorToast) {
        Toast(msg || '网络开小差了...', 3)
      }
      return res
    }
    return res
  },
  error => {
    if (error.message === 'canceled') {
      return Promise.reject(error.message)
    }
    const isTimeout =
      error.code === 'ECONNABORTED' || (typeof error.message === 'string' && error.message.includes('timeout'))
    if (isTimeout) {
      Toast.clear()
    }
    return Promise.reject(new Error(error))
  }
)
/**
 * 检查认证信息
 * @param authType
 * @returns {boolean}
 */
function checkAuthorization(authType = AUTH_TYPE.BEARER) {
  switch (authType) {
    case AUTH_TYPE.BEARER:
      if (Cookie.get(xsrfHeaderName)) {
        return true
      }
      break
    case AUTH_TYPE.BASIC:
    case AUTH_TYPE.AUTH1:
    case AUTH_TYPE.AUTH2:
    default:
      break
  }
  return false
}

/**
 * 加载 axios 拦截器
 * @param interceptors
 * @param options
 */
function loadInterceptors(interceptors, options) {
  const { request, response } = interceptors
  // 加载请求拦截器
  request.forEach(item => {
    let { onFulfilled, onRejected } = item
    if (!onFulfilled || typeof onFulfilled !== 'function') {
      onFulfilled = config => config
    }
    if (!onRejected || typeof onRejected !== 'function') {
      onRejected = error => Promise.reject(error)
    }
    axios.interceptors.request.use(
      function (config) {
        config.headers.appID = ''
        config.headers.channelId = ''
        config.headers.idemToken = ''
        config.headers.requestId = ''
        config.headers.version = ''
        return onFulfilled(config, options)
      },
      function (error) {
        return onRejected(error, options)
      }
      // config => onFulfilled(config, options),
      // error => onRejected(error, options)
    )
  })
  // 加载响应拦截器
  response.forEach(item => {
    let { onFulfilled, onRejected } = item
    if (!onFulfilled || typeof onFulfilled !== 'function') {
      onFulfilled = response => response
    }
    if (!onRejected || typeof onRejected !== 'function') {
      onRejected = error => Promise.reject(error)
    }
    axios.interceptors.response.use(
      response => onFulfilled(response, options),
      error => onRejected(error, options)
    )
  })
}

/**
 * 解析 url 中的参数
 * @param url
 * @returns {Object}
 */
function parseUrlParams(url) {
  const params = {}
  if (!url || url === '' || typeof url !== 'string') {
    return params
  }
  const paramsStr = url.split('?')[1]
  if (!paramsStr) {
    return params
  }
  const paramsArr = paramsStr.replace(/&|=/g, ' ').split(' ')
  for (let i = 0; i < paramsArr.length / 2; i++) {
    const value = paramsArr[i * 2 + 1]
    params[paramsArr[i * 2]] = value === 'true' ? true : value === 'false' ? false : value
  }
  return params
}

export {
  METHOD,
  AUTH_TYPE,
  request,
  setAuthorization,
  removeAuthorization,
  checkAuthorization,
  loadInterceptors,
  parseUrlParams
}
